var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",attrs:{"id":"blog"}},[_c('div',{domProps:{"innerHTML":_vm._s(this.blog_content)}})])}
var staticRenderFns = []

export { render, staticRenderFns }